var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vm-input",class:[
    {'vm-input-maxbo': _vm.maxbo},
    {'vm-input-bold': _vm.bold},
    {'vm-input-disabled': _vm.disabled},
    {'vm-input-valid': _vm.valid},
    {'vm-input-invalid': _vm.invalid},
    {'vm-input-highlight': _vm.highlight},
    {'vm-input-borderless': _vm.borderless},
    {'vm-input-password': _vm.password}
]},[_c('input',{attrs:{"placeholder":_vm.placeholder,"type":_vm.password ? 'password' : '',"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":_vm.handleInput}})])}
var staticRenderFns = []

export { render, staticRenderFns }